// extracted by mini-css-extract-plugin
module.exports = {"next_opening_btn":"EmptySlots_next_opening_btn__8UXVi"};